import { CheckIcon, XIcon } from "@heroicons/react/outline";
import { cn } from "ui";

const BooleanBadge: React.FC<{ value: boolean }> = ({ value }) => {
  return (
    <div
      className={cn(
        "inline-flex h-6 w-6 items-center justify-center rounded-full",
        value && "bg-success-subtler text-success",
        !value && "bg-danger-subtler text-danger"
      )}
    >
      {value ? (
        <CheckIcon className="h-4 w-4" aria-hidden="true" />
      ) : (
        <XIcon className="h-4 w-4" aria-hidden="true" />
      )}
    </div>
  );
};

export default BooleanBadge;
